<template>
  <div class="edit-video-box">
    <el-dialog
      :title="'视频编辑'"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="editParam"
        :rules="rules"
        label-position="left"
        label-width="110px"
      >
        <div class="form-flex-box">
          <el-form-item label="视频标题:">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请谨慎修改数据"
              v-model="editParam.title"
              :disabled="editTitle"
            ></el-input>
            <el-button type="success" size="small" @click="editTitle = false"
              >修改</el-button
            >
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="视频简介:">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请谨慎修改数据"
              v-model="editParam.summary"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="价格:" prop="price">
            <el-input
              v-model.number="editParam.price"
              size="small"
              placeholder="请输入价格"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="editParam.mediaType === 'video'"
            label="免费时长:"
            prop="freeTime"
          >
            <el-input
              v-model.number="editParam.freeTime"
              size="small"
              placeholder="请输入视频免费时长"
            ></el-input>
          </el-form-item>
          <el-form-item label="总集数:" prop="totalEpisode">
            <el-input
              v-model.number="editParam.totalEpisode"
              size="small"
              placeholder="请输入总集数"
            ></el-input>
          </el-form-item>
          <el-form-item label="新版专题排序:" prop="sectionSort">
            <el-input
              v-model.number="editParam.sectionSort"
              size="small"
              placeholder="请输入新版专题排序"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="状态:" prop="isActive">
            <el-select
              v-model.number="editParam.isActive"
              placeholder="请选择状态"
              size="small"
            >
              <el-option label="上架" :value="true"></el-option>
              <el-option label="下架" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="帖子类型:" prop="mediaType">
            <el-select
              :disabled="true"
              v-model.number="editParam.mediaType"
              placeholder="请选择帖子类型"
              size="small"
            >
              <el-option label="视频" value="video"></el-option>
              <el-option label="视频广告" value="video_adv"></el-option>
              <el-option label="漫画" value="image"></el-option>
              <el-option label="小说" value="text"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="封面角标:" prop="isActive">
            <el-select
              v-model.number="editParam.permission"
              placeholder="请选择状态"
              size="small"
            >
              <el-option label="会员" :value="0"></el-option>
              <el-option label="金币" :value="1"></el-option>
              <el-option label="免费" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="子集观看权限:" prop="isActive">
            <el-select
              v-model.number="subListenPermission"
              placeholder="请选择状态"
              size="small"
              @change="changeSubListenPermission"
            >
              <el-option label="会员" :value="0"></el-option>
              <el-option label="金币" :value="1"></el-option>
              <el-option label="免费" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="种类" prop="kind">
            <el-select
              @change="getTagDimensionsList()"
              v-model="editParam.kind"
              placeholder="请选择种类"
              size="small"
              clearable
            >
              <el-option
                v-for="k in kinds"
                :key="k.value"
                :label="k.label"
                :value="k.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维度" prop="dimension">
            <el-select
              @change="getTagList"
              v-model="dimension"
              placeholder="请选择维度"
              size="small"
              clearable
            >
              <el-option
                v-for="k in dimensions"
                :key="k.name"
                :label="k.name"
                :value="k.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="更新状态" prop="dimension">
            <el-select
              @change="changeUpdateSta"
              v-model="editParam.updateStatus"
              placeholder="请选择状态"
              size="small"
            >
              <el-option
                v-for="k in updateTypes"
                :key="k.value"
                :label="k.label"
                :value="k.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排版方向" prop="direction">
            <el-select
              v-model="editParam.direction"
              size="small"
              placeholder="请选择排版方向"
              clearable
            >
              <el-option :value="0" label="横"></el-option>
              <el-option :value="1" label="竖"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="售卖类型" prop="sellType">
            <el-select
              v-model="editParam.sellType"
              size="small"
              placeholder="请选择售卖类型"
              clearable
            >
              <el-option :value="0" label="单集售卖"></el-option>
              <el-option :value="1" label="整部售卖"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item
          label="更新描述:"
          class="updatedDesc"
          v-if="editParam.updateStatus != 0"
        >
          <el-input
            type="text"
            placeholder="请输入更新描述"
            v-model="editParam.updatedDesc"
          ></el-input>
        </el-form-item>
        <div
          class="form-flex-box"
          v-for="(item, i) in editParam.tagSort"
          :key="i"
        >
          <el-form-item label="标签排序:">
            <el-input v-model="item.tagName" size="small" disabled></el-input>
          </el-form-item>
          <el-form-item label="排序号:">
            <el-input v-model.number="item.sortCode" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="标签:" prop="tagObjs">
            <tag-selector
              v-model="editParam.tagObjs"
              :tagList="tagList"
              v-if="isTagSelector"
            ></tag-selector>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="横版封面:" prop="horizontalCover">
            <base-upload
              :cover="editParam.horizontalCover"
              :action="action"
              @successCallback="successCallbackHeng"
              :wSize="640"
              :hSize="360"
              :width="'213px'"
              :height="'120px'"
            ></base-upload>
          </el-form-item>
          <el-form-item label="竖版封面:" prop="verticalCover">
            <base-upload
              :cover="editParam.verticalCover"
              :action="action"
              @successCallback="successCallbackShu"
              :wSize="360"
              :hSize="640"
              :width="'120px'"
              :height="'213px'"
            ></base-upload>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitDate()"
          :loading="flag"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import API from "@/api";
import TagSelector from "@/components/mediaTagSelector";
export default {
  components: {
    TagSelector,
  },
  data() {
    return {
      dialogVisible: false,
      flag: false,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      tagList: [], //标签列表：包含标签名称和标签id
      tag: [],
      editTitle: true,
      editParam: {
        id: "",
        tags: [],
        tagSort: [],
        horizontalCover: "",
        verticalCover: "",
        title: "",
        summary: "",
        isActive: "",
        freeTime: undefined,
        permission: undefined,
        totalEpisode: undefined,
        sectionSort: undefined,
        kind: undefined,
        price: undefined,
        direction: 0,
        sellType: 0,
        sortCode: "",
        type: 0,
        mediaType: "",
        tagObjs: [],
        updatedDesc: undefined,
        updateStatus: 0,
      },
      subListenPermission: undefined,
      updateTypes: [
        { label: "默认", value: 0 },
        { label: "更新中", value: 1 },
        { label: "已完结", value: 2 },
      ],
      // 表单验证规则
      rules: {
        cover: [
          { required: true, message: "请输入添加封面图片", trigger: "blur" },
        ],
        tags: [{ required: true, message: "请选择标签", trigger: "blur" }],
      },
      dimensions: [],
      dimension: "",
      kinds: [
        { label: "动漫", value: 0 },
        { label: "漫画", value: 1 },
        { label: "COS", value: 2 },
        { label: "真人", value: 3 },
        { label: "小说", value: 4 },
        { label: "写真", value: 5 },
        { label: "原作", value: 6 },
      ],
      isTagSelector: false,
    };
  },
  methods: {
    changeUpdateSta() {
      if (this.editParam.updateStatus == 1) {
        this.editParam.updatedDesc = "更新至X话";
      } else if (this.editParam.updateStatus == 2) {
        this.editParam.updatedDesc = "已完结X话";
      } else {
        this.editParam.updatedDesc = undefined;
      }
    },
    getTagList() {
      this.tagList = [];
      if (this.editParam.kind === undefined) {
        this.$message.error("请选择种类");
        return;
      }
      const param = {
        kind: this.editParam.kind,
        dimension: this.dimension,
      };
      API.getMediaTagByKindDimension(param).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data;
        }
      });
    },
    // 提交验证
    submitDate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.editParam.tagObjs.length <= 0) {
            this.$message.error("请选择标签");
            return false;
          }
          var tags = [];
          for (const t of this.editParam.tagObjs) {
            tags.push(t.id);
          }
          this.editParam.tags = tags;
          this.editVideo();
        } else {
          this.flag = false;
          return false;
        }
      });
    },
    // 编辑
    editVideo() {
      API.editMediaInfo(this.editParam)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功！",
              type: "success",
            });
            this.$emit("handlerVideoList");
          } else {
            this.$message.error("编辑失败！");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 请求种类下的维度列表数据
    getTagDimensionsList() {
      this.tagList = [];
      this.dimension = "";
      if (this.editParam.kind === undefined) {
        this.$message.error("请选择种类");
        return;
      }
      API.getMediaTagDimensions({ kind: this.editParam.kind })
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.dimensions = res.data;
          } else {
            this.dimensions = [];
          }
        })
        .catch(() => {
          this.dimensions = [];
        });
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true;
      this.isTagSelector = true;
      this.editParam.id = data.id;
      this.editParam.isActive = data.isActive;
      this.editParam.horizontalCover = data.horizontalCover;
      this.editParam.verticalCover = data.verticalCover;
      this.editParam.title = data.title;
      this.editParam.freeTime = data.freeTime > 2 ? data.freeTime : 3;
      this.editParam.price = data.price;
      this.editParam.sortCode = data.sortCode;
      this.editParam.tags = data.tags ? data.tags.map((item) => item.name) : [];
      this.editParam.mediaType = data.mediaType;
      this.editParam.tagObjs = data.tagObjs || [];
      this.editParam.totalEpisode = data.totalEpisode;
      this.editParam.sectionSort = data.sectionSort;
      this.editParam.permission = data.permission;
      this.editParam.summary = data.summary;
      this.editParam.kind = data.kind;
      this.editParam.updatedDesc = data.updatedDesc;
      this.editParam.updateStatus = data.updateStatus || 0;
      this.editParam.direction = data.direction;
      this.editParam.sellType = data.sellType || 0;
      this.getTagDimensionsList();
    },
    changeSubListenPermission() {
      let req = {
        id: this.editParam.id,
        field: "listenPermission",
        status: this.subListenPermission,
      };
      console.log(123123);
      this.$confirm("您确定批量修改子集状态？", "修改提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.modifySubMediaInfo(req).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.getSubMediaList();
          } else {
            this.$message.error("修改失败！");
          }
        });
      });
    },
    // 关闭回掉
    handleClose() {
      this.dialogVisible = false;
      this.editTitle = true;
      this.isTagSelector = false;
      this.subListenPermission = undefined;
      this.$refs.form.resetFields();
    },
    // 封面图上传成功回调
    successCallbackHeng(res) {
      this.editParam.horizontalCover = res.data.coverImg;
    },
    successCallbackShu(res) {
      this.editParam.verticalCover = res.data.coverImg;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-input {
    width: 150px;
  }
  .activity-box {
    /deep/ .el-input {
      width: 500px !important;
    }
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .updatedDesc {
    /deep/ .el-form-item__content {
      display: flex;
    }
    /deep/ .el-input {
      flex: 1;
    }
  }
}
</style>
